export default {
  methods: {

    updatePage (page, replace) { 
  
      if (page.route) {
        
        var route = {};

        // Page has a target (ie: company) so go there
        if (page.target) route.name = page.target;
  
        // Page is just a regular old page
        else route.name = page.route;

        if (replace) this.$router.replace(route);
        else this.$router.push(route);
      }
      else if (page.action) page.action();

    },

    isSelected (page) {
  
      // Is selected if the route name matches either the route, in the case of company, the target
      return this.$route.name === page.route || page.target && this.$route.name === page.target;
    },

    optionClicked (option) {
      if (option.route) this.updatePage(option, true);
      else if (option.action) option.action();
    }

  }
};


// WEBPACK FOOTER //
// ./src/mixins/navMixin.js